import { SideNav } from "components";
import AttributesForm from "components/Flex/AttributesForm";
import GmcForm from "components/PlanSetup/GmcForm";
import {
    MainBody,
    OverlayLoader,
    PageTitle
  } from "components/core";
import useFlex from "hooks/useFlex";
import { WidthLimiter } from "pages/PlanSetup/styles";
  import React, {useEffect, useState} from "react";
import { useLocation } from "react-router";
import http from "services/httpService";

const AttributeSetup = () =>{
    const { getProductDetails } = useFlex();
    const [productPayload, setProductPayload] = useState()
    const { state } = useLocation();
    const [isLoading, setLoading] = useState(true);
    const [attributeDetails, setAttributeDetails] = useState();
    useEffect(() => {
        const previousPayload = JSON.parse(localStorage.getItem('setup_plan_payload'));
        setProductPayload(previousPayload);
    }, [localStorage.getItem('setup_plan_payload')]);
    useEffect(()=>{
        if(productPayload){(async function () {
            await getProductAttributes();
        })();}
    }, [productPayload]);
    const getProductAttributes = async() => {
        try{
            setLoading(true);
            const { data } = await http.post(
                `business/get_product_level_attributes_setup_details/`,
                productPayload?.attributes
            )
            setAttributeDetails(data)
        } catch(e){
            console.log(e)
            alert("Error happend!")
        } finally{
            setLoading(false)
        }
    }
    return (
        <section>
            {isLoading ? (
                <OverlayLoader/>
            ) : (
                <>
                <SideNav/>
                <MainBody style={{position : "relative", minHeight: "100vh"}}>
                    <WidthLimiter>
                        <PageTitle title={`Setup ${getProductDetails(state.product).display_name}`}
                        />
                        <AttributesForm details={attributeDetails} besicDetails={productPayload}/>
                    </WidthLimiter>
                </MainBody>
                </>
            )}
        </section>
    )
}

export default AttributeSetup